"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageTypes = exports.docsTypes = exports["default"] = exports.compressedTypes = void 0;
var _edSystem = require("@eduact/ed-system");
var _studentTheme = require("@eduact/student-theme");
var _Icons = require("../../Icons");
var _polished = require("polished");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _Tooltip = require("../Tooltip");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var attachmentTypesEnum = ['pdf', 'csv', 'doc', 'image', 'ppt', 'zip', 'rar', 'png', 'jpg', 'jpeg'];
var isAttachmentType = function isAttachmentType(value) {
  return value !== undefined && attachmentTypesEnum.includes(value);
};
var attachmentsColors = {
  doc: '#2b579a',
  csv: '#217346',
  ppt: '#d24726',
  pdf: '#FA0F00',
  rar: '#4F0000',
  zip: '#4F0000',
  image: 'transparent',
  png: 'transparent',
  jpg: 'transparent',
  jpeg: 'transparent'
};
var attachmentsIcons = {
  doc: /*#__PURE__*/_react["default"].createElement(_Icons.Icons.DocFile, null),
  csv: /*#__PURE__*/_react["default"].createElement(_Icons.Icons.CsvFile, null),
  ppt: /*#__PURE__*/_react["default"].createElement(_Icons.Icons.PptFile, null),
  pdf: /*#__PURE__*/_react["default"].createElement(_Icons.Icons.PdfFile, null),
  rar: /*#__PURE__*/_react["default"].createElement(_Icons.Icons.RarFile, null),
  zip: /*#__PURE__*/_react["default"].createElement(_Icons.Icons.ZipFile, null),
  jpg: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
  png: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
  image: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
  jpeg: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)
};
var imageTypes = ['image', 'png', 'jpg', 'jpeg'];
exports.imageTypes = imageTypes;
var compressedTypes = ['zip', 'rar'];
exports.compressedTypes = compressedTypes;
var docsTypes = ['doc', 'pdf'];
exports.docsTypes = docsTypes;
var Attachment = function Attachment(_ref) {
  var _attachmentsColors$ty;
  var _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? 'primary' : _ref$bgColor,
    bgImage = _ref.bgImage,
    type = _ref.type,
    onDelete = _ref.onDelete,
    url = _ref.url,
    _ref$folded = _ref.folded,
    folded = _ref$folded === void 0 ? true : _ref$folded,
    _onClick = _ref.onClick,
    _ref$withDelete = _ref.withDelete,
    withDelete = _ref$withDelete === void 0 ? true : _ref$withDelete;
  var theme = (0, _studentTheme.useEdTheme)();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(AttachmentContainer, {
    flexDirection: 'column'
  }, /*#__PURE__*/_react["default"].createElement(StyledAttachment, {
    onClick: function onClick() {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick({
        url: url,
        type: type
      });
    },
    bgImage: imageTypes.includes(type) ? url : undefined,
    bgColor: (_attachmentsColors$ty = attachmentsColors[type]) !== null && _attachmentsColors$ty !== void 0 ? _attachmentsColors$ty : theme.colors.primary
  }, !imageTypes.includes(type) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isAttachmentType(type) && /*#__PURE__*/_react["default"].createElement(_Icons.Icon, {
    color: "light",
    size: '3rem'
  }, attachmentsIcons[type]), !isAttachmentType(type) && /*#__PURE__*/_react["default"].createElement(_Icons.Icon, {
    color: "light",
    size: '3rem'
  }, /*#__PURE__*/_react["default"].createElement(_Icons.Icons.File, null))), folded && /*#__PURE__*/_react["default"].createElement(AttachmentCorner, null), withDelete && /*#__PURE__*/_react["default"].createElement(RemoveAttachment, {
    onClick: function onClick(e) {
      e.stopPropagation();
      onDelete === null || onDelete === void 0 ? void 0 : onDelete({
        type: type,
        url: url
      });
    }
  }, "Remove", /*#__PURE__*/_react["default"].createElement(_Icons.Icon, {
    color: "light"
  }, /*#__PURE__*/_react["default"].createElement(_Icons.Icons.Trash, null)))), /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, {
    placement: "bottom",
    title: url.split('/').pop()
  }, /*#__PURE__*/_react["default"].createElement(AttachmentURL, null, url.split('/').pop()))));
};
var _default = Attachment;
exports["default"] = _default;
var RemoveAttachment = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: absolute;\n\twidth: 100%;\n\tbackground: ", ";\n\tdisplay: flex;\n\tcolor: ", ";\n\tfont-size: 0.625rem;\n\ttransform: translateY(100%);\n\tjustify-content: space-between;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tpadding: 0.5rem 0.2rem;\n\tcursor: pointer;\n\ttransition: all ease-in-out 200ms;\n"])), (0, _polished.rgba)('#000', 0.5), function (props) {
  return props.theme.colors.light;
});
var AttachmentContainer = (0, _styledComponents["default"])(_edSystem.FlexLayout)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tmax-width: 76px;\n"])));
var AttachmentURL = (0, _styledComponents["default"])(_edSystem.Typography)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tdisplay: block;\n\tfont-size: 0.75rem;\n\tmax-width: 76px;\n\tmargin-top: 0.5rem;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
var StyledAttachment = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tposition: relative;\n\twidth: 76px;\n\theight: 76px;\n\tborder-radius: 3px;\n\t", ";\n\tbackground: ", ";\n\toverflow: hidden;\n\tdisplay: grid;\n\tplace-content: center;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\t&:hover {\n\t\t", " {\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n"])), (0, _styledSystem.variant)({
  scale: 'backgrounds',
  prop: 'bgColor'
}), function (props) {
  return props.bgImage ? "url(".concat(props.bgImage, ")") : props.bgColor;
}, RemoveAttachment);
var AttachmentCorner = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\twidth: 1rem;\n\theight: 1rem;\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tbackground-color: #e6e7e8;\n\t::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\twidth: 0;\n\t\theight: 0;\n\t\tborder-style: solid;\n\t\tborder-width: 0 1em 1em 0;\n\t\tborder-color: transparent #fff transparent transparent;\n\t}\n"])));